import axios from 'axios';
import Resource from './Resource'

export default class Member extends Resource {
  static ENDPOINT = '/api/member'

  constructor (args) {
    super(args)
    this.extend(args)
  }

  static create (args) {
    return new Member(args)
  }

  static async studentList (training) {
    if (!training) return [];
    return await this.list({ training, role: 'STUDENT' })
  }

  static async teacherList (org) {
    return await this.list({ role: 'TEACHER', org })
  }

  static async managerList (org) {
    if (!org) return [];
    return await this.list({ org, role: 'MANAGER' });
  }
}
